import { useGetOutageByIdQuery } from '@/apis/outages/outagesApi';
import { SPINNER_SIZE } from '@/constants';
import {
  Icon,
  LoadingSpinner,
  Stack,
  Typography,
} from '@data-products-and-ai/react-components';
import { useLocation, useParams } from 'react-router';
import {
  OutageDetails,
  OutageMillwrights,
} from '@/pages/Outages/[ID]/components';
import { BackButton } from '@/components';
import { useGetTasksByOutageIdQuery } from '@/apis/tasks/tasksApi';
import { OUTAGES_ROUTE } from '@/pages/Outages/routes';

import '@/pages/Outages/[ID]/styles.scss';

export const OutagePage: React.FC = () => {
  const { outageId } = useParams();
  const outageID = Number(outageId);
  const location = useLocation();
  const backUrl = (location.state as { from?: string } | null)?.from;

  const { data: outage, isLoading: isOutageLoading } = useGetOutageByIdQuery(
    outageID,
    {
      skip: !outageID,
    },
  );
  const { data: tasksData, isLoading: isTasksLoading } =
    useGetTasksByOutageIdQuery(outageID, { skip: !outageID });
  const tasks = tasksData?.results || [];
  const isLoading = isOutageLoading || isTasksLoading;

  if (isLoading)
    return (
      <div className="outages-page-spinner">
        <LoadingSpinner
          text="Loading outage..."
          size={SPINNER_SIZE}
          color="var(--color-primary)"
          align="center"
          tag="textdefault"
          inline
        />
      </div>
    );

  if (!outage) return null;

  return (
    <div className="outage-page">
      <Stack wrap direction="row" distribute="space-between" gap={16}>
        <Typography color="var(--color-black)" tag="h3">
          {outage.outageName || outage.outageId}
        </Typography>
        <BackButton url={OUTAGES_ROUTE} from={backUrl} />
      </Stack>
      <OutageDetails outage={outage} tasks={tasks} />
      <Stack inline verticalAlign="center">
        <Icon iconSize={1} color="var(--color-default)" icon="IconArrowDown" />
      </Stack>
      <OutageMillwrights outageId={outage.outageId} />
    </div>
  );
};
